import './home.css'
import Services from "../services/Services";
import AboutUs from "../about-us/AboutUs";
import Success from "../../success/Success";

import {Helmet} from "react-helmet";
import React from "react";

const Home = () => {

    return (
        <div>
            <div className="container home">
                <div className="home-service">
                    <div className="title">
                        <h2> Services </h2>
                    </div>
                    <Services></Services>
                </div>
                <div className="home-about mt-5 pt-4">
                    <div className="title">
                        <h2> About </h2>
                    </div>
                    <AboutUs></AboutUs>
                </div>
                <div className="home-success mt-5 pt-4">
                    <div className="title">
                        <h2> Success Story </h2>
                    </div>
                    <Success></Success>
                </div>
            </div>
            <Helmet>
                <title> React Developer </title>
                <meta
                    name="React Developer"
                    content="React Developer"
                />
            </Helmet>
        </div>
    );
};

export default Home;